module.exports = __webpack_public_path__ + "img/presentation.e28a372c.svg";